var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7988 7.44624C16.7317 7.43666 16.6646 7.43666 16.5975 7.44624C15.1121 7.39832 13.9333 6.18124 13.9333 4.68624C13.9333 3.16249 15.1696 1.91666 16.7029 1.91666C18.2267 1.91666 19.4725 3.15291 19.4725 4.68624C19.4629 6.18124 18.2842 7.39832 16.7988 7.44624Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9253 14.0879C18.852 14.8066 17.3474 15.075 15.9578 14.8929C16.322 14.1071 16.5137 13.235 16.5232 12.315C16.5232 11.3566 16.3124 10.4462 15.9099 9.6508C17.3282 9.45914 18.8328 9.72747 19.9157 10.4462C21.4299 11.4429 21.4299 13.0816 19.9253 14.0879Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17186 7.44624C6.23894 7.43666 6.30602 7.43666 6.37311 7.44624C7.85852 7.39832 9.03727 6.18124 9.03727 4.68624C9.03727 3.15291 7.80102 1.91666 6.26769 1.91666C4.74394 1.91666 3.50769 3.15291 3.50769 4.68624C3.50769 6.18124 4.68644 7.39832 6.17186 7.44624Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27817 12.3152C6.27817 13.2447 6.47942 14.1264 6.84359 14.9218C5.49234 15.0656 4.08359 14.7781 3.04859 14.0977C1.53442 13.0914 1.53442 11.4527 3.04859 10.4464C4.07401 9.7564 5.52109 9.47848 6.88192 9.63182C6.48901 10.4368 6.27817 11.3472 6.27817 12.3152Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6157 15.2087C11.5391 15.1992 11.4528 15.1992 11.3666 15.2087C9.60323 15.1512 8.19446 13.7042 8.19446 11.9217C8.20404 10.1008 9.67031 8.625 11.5007 8.625C13.3216 8.625 14.7974 10.1008 14.7974 11.9217C14.7878 13.7042 13.3886 15.1512 11.6157 15.2087Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50121 17.1931C7.05412 18.161 7.05412 19.7518 8.50121 20.7102C10.1496 21.8122 12.8521 21.8122 14.5004 20.7102C15.9475 19.7422 15.9475 18.1514 14.5004 17.1931C12.8616 16.091 10.1591 16.091 8.50121 17.1931Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonorIcon);
export default __webpack_public_path__ + "static/media/donor-icon.27a7330bde0443924d990be3049f1792.svg";
export { ForwardRef as ReactComponent };